import type {
  EducationDetail,
  ProfileDetail,
  ProfileSkillDetail,
  ProjectDetail,
} from "@/interface";
import { ProfileCompletionCard } from "@/components/profile/ProfileCompletionCard";

interface CandidateSidebarProps {
  profile: ProfileDetail;
  skillsList?: ProfileSkillDetail[];
  projectsList?: ProjectDetail[];
  educationList?: EducationDetail[];
}

export function CandidateSidebar({ profile }: CandidateSidebarProps) {
  return (
    <div className="w-full xl:w-80 flex flex-col gap-6 shrink-0">
      <ProfileCompletionCard
        profileId={profile?.id}
        showViewDetails={false}
      />
    </div>
  );
}
